module.exports = __webpack_public_path__ + "img/AppsyPretty2-1040x500.2db3e007.jpg";